import Vue from 'vue'
import Router from 'vue-router'
import Analysis from '@/views/dashboard/Analysis'
import Home from '@/views/dashboard//Home'
import HzProduct from '@/views/product/HzProduct'
import HzHyal from '@/views/about/HzHyal'
import HzUs from '@/views/about/HzUs'
import HzContact from '@/views/about/HzContact'
import HzControl from '@/views/controlCab/HzControl'
import HzDetails from '@/views/details/HzDetails'

Vue.use(Router)

export default new Router({
  //base: './',
  routes: [
    {
      path: '/',
      name: 'Analysis',
      component: Analysis,
      redirect: 'home',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: Home
        },
        {
          path: 'hzControl',
          name: 'HzControl',
          component: HzControl
        },
        // 产品中心
        {
          path: 'hzProduct',
          name: 'HzProduct',
          component: HzProduct,
        },
        // {
        //   path:'/hzProduct/:id',
        //   name:'HzProduct',
        //   component:HzProduct,
        // },
        {
          path: 'hzHyal',
          name: 'HzHyal',
          component: HzHyal,
        },
        {
          path: 'hzUs',
          name: 'HzUs',
          component: HzUs,
        },
        {
          path: 'hzContact',
          name: 'HzContact',
          component: HzContact,
        },
        {
          path: 'hzDetails',
          name: 'HzDetails',
          component: HzDetails,
        }
      ]
    },

  ],
  mode: 'history'
})




// WEBPACK FOOTER //
// ./src/router/index.js